/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import {
  Descriptions,
  Card,
} from 'antd';
import ReactJson from 'react-json-view';

import { getQueueMessageById } from '../../redux/actions/QueueMessage';

const QueueMessageDetailsForModal = ({ queueMessageId }) => {
  const dispatch = useDispatch();
  const { queue_message: { data } } = useSelector(({ queue_message }) => queue_message);

  useEffect(() => {
    if (queueMessageId) {
      dispatch(getQueueMessageById(queueMessageId));
    }
  }, [dispatch, queueMessageId]);

  return data && data._id ? (
    <div>
      <div className="justify-content-center">
        <Card title={data.queue_name}>
          <Descriptions layout="vertical">
            <Descriptions.Item label="Details" span={3}>
              <ReactJson src={data} collapsed />
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </div>
    </div>
  ) : '';
};

QueueMessageDetailsForModal.propTypes = {
  queueMessageId: PropTypes.string,
};

QueueMessageDetailsForModal.defaultProps = {
  queueMessageId: '',
};
export default QueueMessageDetailsForModal;
